<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Select payment method to refund</ion-title>
  </ion-toolbar> 
</ion-header>
<ion-content>
  <ion-list>
    <ion-item *ngIf="paidByCard" tappable (click)="selectMethod('card')"><b>Card ending in {{ cardInfo.last4Digits }} exp {{ cardInfo.expDate }}</b></ion-item>
    <ion-item tappable (click)="selectMethod('cash')">Cash</ion-item>
    <ion-item tappable (click)="selectMethod('external')">External Payment</ion-item>
  </ion-list>
</ion-content>